// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2OAh9","containerItemsCenter":"Skeleton_containerItemsCenter__34FE2"};